/**
 * Created by robincoburn on 31/07/15.
 */


angular.module('qkr.coupon').config($routeSegmentProvider => {
    $routeSegmentProvider.options.autoLoadTemplates = true;

    $routeSegmentProvider.
        when('/merchant/coupons', 'coupons', { pageTitle: 'Coupon Management' }).
        when('/merchant/coupon/create', 'createCoupon').
        when('/merchant/coupon/edit/:couponId', 'editCoupon');

    $routeSegmentProvider.
        segment('coupons', {
            controller: 'couponController',
            template: require('../../coupons/templates/coupons.html'),
            resolve: {
                couponListInitData(couponService) {
                    'ngInject';
                    return couponService.resolveList();
                },
                merchantInfo(merchantService) {
                    'ngInject';
                    return merchantService.loadMerchantInfo();
                }
            },
            untilResolved: {
                template: require('../../shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('../../shared/loading-error.html')
            }
        }).
        segment('createCoupon', {
            controller: 'couponCreateController',
            template: require('../../coupons/templates/createCoupon.html'),
            resolve: {
                createCouponInitData(couponService) {
                    'ngInject';
                    return couponService.resolve(false);
                }
            },
            untilResolved: {
                template: require('../../shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('../../shared/loading-error.html')
            }
        }).
        segment('editCoupon', {
            controller: 'couponCreateController',
            template: require('../../coupons/templates/createCoupon.html'),
            dependencies: ['couponId'],
            resolve: {
                createCouponInitData(couponService) {
                    'ngInject';
                    return couponService.resolve(true);
                }
            },
            untilResolved: {
                template: require('../../shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('../../shared/loading-error.html')
            }
        });
});



// WEBPACK FOOTER //
// ./src/coupons/config/coupon.config.js